export interface ZapPoint { x: number; y: number }

const ZAP = 'rd:zap';
const SECTION = 'rd:section';

/** Fire one bright token along an arc from `from` into `to` (viewport coordinates). */
export const emitZap = (from: ZapPoint, to: ZapPoint) =>
  window.dispatchEvent(new CustomEvent<{ from: ZapPoint; to: ZapPoint }>(ZAP, { detail: { from, to } }));

export const emitSectionChange = () => window.dispatchEvent(new Event(SECTION));

export const onZap = (fn: (from: ZapPoint, to: ZapPoint) => void) => {
  const h = (e: Event) => {
    const { from, to } = (e as CustomEvent<{ from: ZapPoint; to: ZapPoint }>).detail;
    fn(from, to);
  };
  window.addEventListener(ZAP, h);
  return () => window.removeEventListener(ZAP, h);
};

export const onSectionChange = (fn: () => void) => {
  window.addEventListener(SECTION, fn);
  return () => window.removeEventListener(SECTION, fn);
};

export const rectCenter = (el: Element): ZapPoint => {
  const r = el.getBoundingClientRect();
  return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
};

/**
 * Center of the element as laid out, ignoring a flip or rotate on it or its parents.
 * A shot measured with getBoundingClientRect mid-flip lands beside the icon.
 */
export const restingCenter = (el: HTMLElement): ZapPoint => {
  let x = el.offsetWidth / 2;
  let y = el.offsetHeight / 2;
  let node: HTMLElement | null = el;
  while (node) {
    x += node.offsetLeft;
    y += node.offsetTop;
    node = node.offsetParent as HTMLElement | null;
  }
  return { x: x - window.scrollX, y: y - window.scrollY };
};
